module.exports = __webpack_public_path__ + "img/電気回路_2_1_2.45774222.png";